import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import Publish from './publish'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Announcements)',
  collection: {
    endpoint: '/api/admin/truevail/admin/announcements',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Announcement)', key: 'title', sort: 'title', primary: true },
      { label: 't(Status)', key: 'status', sort: 'status', collapsing: true, format: StatusToken }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'megaphone',
      title: 't(No Announcements)',
      text: 't(You have not yet created any announcements)',
      buttons: [
        {
          label: 't(Create Announcement)',
          modal: New
        }
      ]
    },
    entity: 'announcement',
    recordTasks: (record) => [
      {
        label: 't(Publish Announcement)',
        svg: 'check',
        show: record.status !== 'published',
        modal: <Publish announcement={ record } />
      },
      {
        label: 't(Unpublish Announcement)',
        svg: 'x',
        show: record.status === 'published',
        request: {
          endpoint: `/api/admin/truevail/admin/announcements/${record.id}/publish`,
          method: 'PATCH',
          body: {
            strategy: 'unpublish'
          },
          onSuccess: () => context.flash.set('success', 't(Successfully unpublished this announcement)'),
          onFailure: () => context.flash.set('error', 't(Unable to unpublish this announcement)')
        }
      },
      {
        label: 't(Delete Announcement)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this announcement?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/announcements/${record.id}`,
          method: 'DELETE',
          onFailure: (result) => context.flash.set('error', 'Unable to delete announcement'),
          onSuccess: (result) => context.flash.set('success', 'Announcement was deleted successfully')
        }
      }
    ],
    onClick: (announcement) => context.router.push(`/admin/truevail/admin/announcements/${announcement.id}`)
  },
  task: {
    svg: 'plus',
    modal: New
  }
})

export default Panel(null, mapPropsToPanel)
